// extracted by mini-css-extract-plugin
export default {"sub-navbar":"tournament-navbar_sub-navbar__zQTXC","sub-navbar-links":"tournament-navbar_sub-navbar-links__P-P5d"};